module.exports = __webpack_public_path__ + "static/login-background-3e11aed22fb55bb2c063b3e8d220937c.png";